import { all } from 'redux-saga/effects';

import transactions from './settings';

function* watch() {
  yield all([transactions.saga.watch()]);
}

export default {
  watch,
};
